var dialog = document.getElementById("popUp");
var overlay = document.getElementById("overlayContainer");
var body = document.body;
var scrollPosition = 0;
var main = document.querySelector(".body_apolo");

function openDialog(element) {
    var productId = element.getAttribute("product_id");
    var optionsDiv = document.querySelector(`.options_movil_${productId}`);

    if (optionsDiv) {
        var infoDinamica = optionsDiv.innerHTML;
        document.getElementById("popupContent").innerHTML = infoDinamica;

        // Guardar la posición de scroll y deshabilitar el desplazamiento
        scrollPosition = window.pageYOffset;
        body.style.top = `-${scrollPosition}px`;
        body.classList.add("noscroll");

        // Mostrar el overlay y el popup
        overlay.classList.add("overlayActive");
        dialog.classList.add("popUpActive");
    }
}

function closeDialog() {
    // Habilitar nuevamente el desplazamiento
    body.classList.remove("noscroll");
    overlay.classList.remove("overlayActive");
    dialog.classList.remove("popUpActive");

    // Restaurar la posición de scroll
    window.scrollTo(0, scrollPosition);
}

 

// Manejar el evento click para cerrar el diálogo cuando se hace clic fuera del popup
overlay.addEventListener('click', function (event) {
    if (event.target === overlay) {
        closeDialog();
    }
});

     
    main.addEventListener("click", function (event) {
        var button_options = event.target.closest('.button_options');
        if (button_options) {
          handleSizeButtonClick(event, event.target);
         }
        var productLink = event.target.closest('.product-link');
        if (productLink) {
            event.preventDefault(); // Evitar que el enlace se abra
    
            const parentElement = productLink.parentNode;
    
            // Remover la clase 'active' de todos los enlaces dentro del padre
            parentElement.querySelectorAll('a').forEach(e => {
                e.classList.remove('active');
            });
    
            // Remover las clases 'disabled_tacha' y 'active' de los divs dentro del padre
            parentElement.querySelectorAll('a div').forEach(a => {
                a.classList.remove('disabled_tacha');
                a.classList.remove('active');
            });
    
            // Agregar la clase 'active' al enlace clickeado
            productLink.classList.add('active');
    
            // Obtener valores de los atributos personalizados
            var imgUrl = productLink.getAttribute('img_url');
            var product_id = productLink.getAttribute('product_id');
            var product_url = productLink.getAttribute('product_url');
            var section_id = productLink.getAttribute('section_id');
            var precio_original = productLink.getAttribute('price_original');
            var precio_oferta = productLink.getAttribute('price_sale');
            var html_options = productLink.getAttribute('html_options');
           var variant_id_apolo = productLink.getAttribute('variant_id_apolo');
     
            // Actualizar precios
            var divsMain_price = document.querySelectorAll('.price_' + product_id + '_' + section_id);
            divsMain_price.forEach(function (divMain_price) {
                var price_sale = divMain_price.querySelector('.price-item--sale');
                var price_regular = divMain_price.querySelector('.apolo_regular');
                var title = divMain_price.querySelector('.title_apolo');
                title.setAttribute('href', product_url);
    
                if (precio_original) {
                    price_regular.textContent = precio_original;
                }
                if (precio_oferta) {
                    price_sale.textContent = precio_oferta;
                }
            });
    
            // Actualizar contenedor principal
            var divsMain = document.querySelectorAll('.apolo_' + product_id + '_' + section_id);
            divsMain.forEach(function (divMain) {
                var container_options = divMain.querySelector('.container_options');
                var btn_add_to_cart = divMain.querySelector('.btn_add_to_cart');
                var icon_bag_apolo = divMain.querySelector('.icon_bag_apolo');
              console.log(divsMain);
              console.log(icon_bag_apolo);
              console.log(product_id);
                container_options.innerHTML = ''; // Limpia el contenido actual
                container_options.innerHTML = html_options; // Inserta nuevas opciones
    
                // Actualizar imagen y otros atributos
                const imageMain = divMain.querySelector('img');
                divMain.setAttribute('data-product-url', product_url);
                icon_bag_apolo.setAttribute('product_id', variant_id_apolo);
                btn_add_to_cart.setAttribute('data-product-id', product_id);
                imageMain.srcset = imgUrl;
            });
        }
 
       // Verificar si el clic ocurrió en un card con URL
        var card = event.target.closest('[data-product-url]');
        if (card && !event.target.closest('.button_options') && !event.target.closest('.product-link') && !event.target.closest('.btn_add_to_cart') && !event.target.closest('.movil_options') ) {
            redirectToProduct(card);
        }

            // Verifica si el clic proviene de un botón con la clase 'btn_add_to_cart'
        var button = event.target.closest('.btn_add_to_cart');
        if (button) {
            event.preventDefault(); // Previene cualquier acción predeterminada del botón, si existe

            var productId = button.getAttribute('data-product-id');
           
            if (productId) {
                addToCart(productId);
            } else {
                console.error('No se encontró el atributo "data-product-id" en el botón.');
            }
        }

        var svgIcon = event.target.closest('.icon_bag_apolo');
        if (svgIcon) {
            event.preventDefault(); // Evitar comportamiento predeterminado si lo hay
            openDialog(svgIcon);
        }
    });
  
    function redirectToProduct(cardElement) {
        // Obtén la URL del atributo data-product-url
        var productUrl = cardElement.getAttribute('data-product-url');
        
        if (productUrl) {
            // Redirige a la URL del producto
            window.location.href = productUrl;
        } else {
            console.error("No se encontró una URL válida en el card.");
        }
    }

    function handleSizeButtonClick(event, button) {
        event.stopPropagation();
        
        // Elimina la clase 'selected' de todos los botones
        var buttons = document.querySelectorAll(".btn_apolo");
        buttons.forEach(function (btn) {
            btn.classList.remove("selected");
        });
        
        // Agrega la clase 'selected' al botón clickeado
        button.classList.add("selected");
    }


    
    async function addToCart(id) {
   
        
        // Mostrar el fondo de carga
        showLoadingOverlay();
    
        var selectedSizeButton = body.querySelector(".btn_apolo.selected");
        var variantSize = selectedSizeButton.getAttribute("data-variant-size");
    
        var productId = id;
        var variantsDiv = body.querySelector(".variants_" + productId);
        console.log(variantsDiv);
        var variantNodes = variantsDiv.querySelectorAll(".variant_id_op");
        var variantId_final = null;
        variantNodes.forEach((node) => {
          var [id, option] = node.textContent
            .trim()
            .split("-")
            .map((item) => item.trim());
          if (option === variantSize) {
            variantId_final = id;
            return; // Salir del bucle forEach cuando se encuentre la variante correspondiente
          }
        });
    
        var variantId = variantId_final;
        var quantity = 1; // Puedes ajustar la cantidad si es necesario
    
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: variantId,
                  quantity: quantity,
                }),
            });
            
            if (!response.ok) throw new Error('Failed to add to cart');
 
        } catch (error) {
            console.error('Error:', error);
            console.log('An error occurred while updating your cart. Please try again later.');
        } finally {
             updateCartDrawer();
            // Ocultar el fondo de carga después de la operación
            hideLoadingOverlay();
        }
    }
    
    // Función para mostrar el fondo de carga
    function showLoadingOverlay() {
        // Crear un elemento de overlay si no existe
        let overlay = document.querySelector('#loadingOverlay');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'loadingOverlay';
            overlay.style.position = 'fixed';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.7)';
            overlay.style.zIndex = '9999';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';
            overlay.style.color = 'white';
            overlay.style.fontSize = '20px';
            overlay.style.fontWeight = 'bold';
            overlay.style.textAlign = 'center';
            overlay.innerHTML = 'Cargando...';
            document.body.appendChild(overlay);
        } else {
            overlay.style.display = 'flex'; // Mostrar el overlay si ya existe
        }
}
    
    // Función para ocultar el fondo de carga
    function hideLoadingOverlay() {
        const overlay = document.querySelector('#loadingOverlay');
        if (overlay) {
            overlay.style.display = 'none';
        }
}


    async function addToCart_movil(event, productId) {
      event.stopPropagation();
    
      // Obtén el tamaño seleccionado desde el evento de clic
      var selectedSizeButton = event.target;
      var variantSize = selectedSizeButton.getAttribute("data-variant-size");
    
      // Busca el contenedor de las variantes del producto
      var variantsDiv = document.querySelector(".variants_" + productId);
 
      // Buscar la variante que coincida con el tamaño seleccionado
      var variantNodes = variantsDiv.querySelectorAll(".variant_id_op");
      var variantId_final = null;
      variantNodes.forEach((node) => {
        var [id, option] = node.textContent
          .trim()
          .split("-")
          .map((item) => item.trim());
        if (option === variantSize) {
          variantId_final = id;
          return;
        }
      });
    
      if (!variantId_final) {
        console.error(
          "No se encontró una variante que coincida con el tamaño:",
          variantSize
        );
        return;
      }
       var quantity = 1; // Cambia la cantidad según sea necesario
       try {
                const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  id: variantId_final,
                  quantity: quantity,
                }),
              });
              if (!response.ok) throw new Error('Failed to add to cart');
              updateCartDrawer();
            } catch (error) {
              console.error('Error:', error);
              console.log('An error occurred while updating your cart. Please try again later.');
        }
     
}

    async function updateCartDrawer() {
      try {
        const response = await fetch(`${routes.cart_url}?section_id=cart-drawer`); // Obtener contenido del cart-drawer
        if (!response.ok) throw new Error('Failed to fetch cart drawer');
    
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const newCartDrawerContent = html.querySelector('cart-drawer');
    
        if (newCartDrawerContent) {
          const existingCartDrawer = document.querySelector('cart-drawer');
          if (existingCartDrawer) {
            existingCartDrawer.replaceWith(newCartDrawerContent); // Reemplaza el contenido
          } else {
            document.body.appendChild(newCartDrawerContent); // Si no existe, lo añade
          }
        }
    
        openCartDrawer(); // Abre el cart drawer
    
      } catch (error) {
        console.error('Error updating cart drawer:', error);
      }
    }
    function openCartDrawer() {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      }
}
 
 
